import * as React from 'react';
import { Center, ChakraProvider, Spinner, useMediaQuery } from '@chakra-ui/react';
import { CenteredLayout } from './components/common/Layout/CenteredLayout';
import { Theme } from './theme/Theme';
import { useCallback, useState } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { ObjectsBookmarksView } from './views/objects/ObjectsBookmarksView';
import { BookingView } from './views/objects/BookingView';
import ReactDOM from 'react-dom';
import { ObjectsView } from './views/objects/ObjectsView';
import { ObjectView } from './views/objects/ObjectView';
import './styles/LightGalleryOverrides.css';
import { APP_VIEW, getAppView } from './services/VersionManagement/VersionManagementService';
import { BookingCalendarReadOnly } from './components/Object/BookingCalendar/BookingCalendarReadOnly';

const BookingApp = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [appView] = useState<APP_VIEW>(getAppView());
  const [isTabletOrMobile] = useMediaQuery('(max-width: 767px)')
  const handleLoadingSpinner = useCallback((value: boolean) => {
    setIsLoading(value);
  }, []);
  const [switchBookingCalendarModal, setSwitchBookingCalendarModal] = useState(false);
  const objectId = document.querySelector('[data-object]')?.getAttribute('data-object');
  const handleBookingCalendarModal = useCallback((value = false) => setSwitchBookingCalendarModal(value), []);
  return (
    <React.StrictMode>
      <ChakraProvider theme={Theme}>
        <CenteredLayout>
          <>
            {appView === APP_VIEW.CALENDAR && objectId ? (
              <BookingCalendarReadOnly
                objectId={objectId}
                switchBookingCalendarModal={switchBookingCalendarModal}
                handleBookingCalendarModal={handleBookingCalendarModal}
              />
            ) :
              (<>
                {isLoading && (
                  <Center minHeight={'100vh'}>
                    <Spinner
                      thickness='4px'
                      speed='0.65s'
                      emptyColor='gray.200'
                      color='blue.500'
                      size='xl'
                    />
                  </Center>
                )}
                <Router>
                  <Switch>
                    <Route
                      path={
                        '/objects/:id/:numberOfAdults?/:numberOfChildren?/:agesOfChildren?/:numberOfPets?/:fromDate?/:toDate?'
                      }>
                      <ObjectView handleLoadingSpinner={handleLoadingSpinner} isLoading={isLoading} />
                    </Route>
                    <Route
                      path={
                        '/bookings/:id/:numberOfAdults/:numberOfChildren/:agesOfChildren/:numberOfPets/:fromDate/:toDate'
                      }>
                      <BookingView handleLoadingSpinner={handleLoadingSpinner} isLoading={isLoading} />
                    </Route>
                    <Route path={'/bookmarks'}>
                      <ObjectsBookmarksView
                        handleLoadingSpinner={handleLoadingSpinner}
                        isLoading={isLoading}
                      />
                    </Route>
                    <Route exact
                      path={'/:numberOfAdults?/:numberOfChildren?/:agesOfChildren?/:numberOfPets?/:numberOfBedrooms?/:cities?/:regions?/:features?/:fromDate?/:toDate?'}>
                      <ObjectsView handleLoadingSpinner={handleLoadingSpinner} isLoading={isLoading} />
                    </Route>
                  </Switch>
                </Router>
              </>
              )
            }
          </>
        </CenteredLayout>
      </ChakraProvider>
    </React.StrictMode>
  );
};

ReactDOM.render(<BookingApp />, document.getElementById('alpdesk-booking-app alpdesk-app'));
